import { useEffect } from 'react';
import { clearMultiSelection } from '@components/MainStage/clearMultiSelection';
import { getFocusOnState } from '@components/MainStage/focusOn.store';
import { Modes } from '@constants/canvas/layers';
import { useProject } from '@context/Project';
import useAssets from '@hooks/useAssets';

const useClearFocusOnAsset = () => {
  const {
    toolbox: { mode },
  } = useProject();

  const { selectedAssetId, isNewAssetMode } = useAssets();

  useEffect(() => {
    if (mode !== Modes.RiskManagement) return;

    getFocusOnState().clear();
    clearMultiSelection();
  }, [mode, selectedAssetId, isNewAssetMode]);
};

export default useClearFocusOnAsset;
